/** @format */

import template from './gb-add-item-table-widget.html';
import _ from 'lodash';

export const GbAddItemTableWidgetComponent = {
    template,
    require: {
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbAddItemTableWidgetComponent {
        constructor($gbItemTableProjectorWidget, $translate, $mdColors) {
            'ngInject';

            this.$gbItemTableProjectorWidget = $gbItemTableProjectorWidget;
            this.$translate = $translate;
            this.$mdColors = $mdColors;

            this.listTableDefaults = {
                columns: 1,
                rows: 5,
                slide_interval: 10,
                x: 10,
                y: 10,
                x_unit: '%',
                y_unit: '%',
                width: 80,
                width_unit: '%',
                height: 80,
                height_unit: '%',
                opacity: 1,
                font_size: 10,
                card_type: 'standard_table',
            };

            this.gridTableDefaults = {
                columns: 5,
                rows: 1,
                slide_interval: 10,
                x: 10,
                y: 25,
                x_unit: '%',
                y_unit: '%',
                width: 80,
                width_unit: '%',
                height: 50,
                height_unit: '%',
                opacity: 1,
                font_size: 10,
                card_type: 'tall_card',
            };

            this.defaultTableColors = {
                table_primary_color: this.$mdColors.getThemeColor('default-primary'),
                table_accent_color: this.$mdColors.getThemeColor('default-accent'),
                table_background_color: this.$mdColors.getThemeColor('default-background'),
            };
        }

        getWidget() {
            return this.widget;
        }

        addWidget() {
            let widget = new this.$gbItemTableProjectorWidget(this.listTableDefaults);
            _.assign(widget, this.defaultTableColors);

            this.gbPresenter.tempWidgets.push(widget);
        }
    },
};
